import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function FloatingOrderButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 800);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div
      className={`md:hidden fixed bottom-5 left-1/2 -translate-x-1/2 z-50 transition-all duration-500 ${
        visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
    >
      <Link
        to="/custom-orders"
        className="flex items-center gap-2 bg-blush-500 hover:bg-blush-600 active:scale-95 text-white text-sm font-bold tracking-wide px-6 py-3 rounded-full shadow-lg whitespace-nowrap transition-all duration-200 cursor-pointer"
      >
        <span className="w-5 h-5 flex items-center justify-center">
          <i className="ri-cake-2-line text-base" />
        </span>
        Order Now
      </Link>
    </div>
  );
}
